'use strict';
import $ from 'jquery';
import 'select2';

export default class M94 {
  static init() {
    $('.module-m94').each((index, el) => {
      new M94($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    const self = this;
    this.el.find('.tabs-nav').each(function () {
      $(this).find('a:first-child').addClass('active');
    });

    // $('.tabs-nav a:first-child').addClass('active');
    this.el.find('.tab-content').each(function () {
      $(this).find('.tabContent').hide()
      $(this).find('.tabContent:first-child').show()
    });

    this.el.find('.tabs-nav a').on('click', function () {
      self.el.find('.tabs-nav a').removeClass('active');
      $(this).addClass('active');
      self.el.find('.tabContent').hide();
      const activeTab = $(this).attr('href');
      $(activeTab).fadeIn();
      return false;
    });

    this.el.find('.tooltip-wrap').on('click focus', function () {
      $(this).addClass('active');
      return false
    });

    $(document).on('click', function () {
      if ($('.tooltip-wrap').is(':visible')) {
        $('.tooltip-wrap').removeClass('active');
      }
    });

    this.el.find('.view-feature').on('click', function () {
      if ($(this).parents('ul').hasClass("activeul")) {
        $(this).parents('ul').removeClass('activeul');
      } else {
        self.el.find('.table-listing ul.activeul').removeClass('activeul');
        $(this).parents('ul').addClass('activeul');
      }
    });

    let parent = this.el.find('.module-m94-mobile-nav select').closest('.filter-selected');
    console.log("parent: ", parent);
    this.el.find('.module-m94-mobile-nav select').select2({
      minimumResultsForSearch: Infinity,
      // allowClear: true,
      dropdownParent: parent,
    });
    this.el.find('.module-m94-mobile-nav select').on('select2:select', (e) => {
      const option = $(e.params.data.element);
      const tab = option.data('tab');
      console.log("tab: ", tab);
      self.el.find('.tabContent').hide();
      $(tab).show();
    });
  }
}

